/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IActiveImageViewProps } from './dobbies-product-carousel';

export const activeImageView: React.FC<IActiveImageViewProps> = props => {
    return (
        <Module {...props.activePointContainer}>
            <Node {...props.activePointImageContainer}>
                {props.imageMapper}
                {props.additionalContent}
            </Node>
            {props.productCard}
            <Node {...props.activePointDetailsContainer}>{props.featuredProducts}</Node>
        </Module>
    );
};

export default activeImageView;
